import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import UspSection from '@client/containers/uspSection/UspSection';
import hero_collaborate from '@client/shared/styles/assets/images/header-collaborate.jpg';
import collaborateUspImage from '@client/shared/styles/assets/images/collaborate-usp.jpg';
import hero_collaborators from '@client/shared/styles/assets/images/hero_collaborators.jpg';
import { strings } from '@client/localization/Localization';
import HeroSection from '@client/containers/heroSection/HeroSection';
import shapes from '@client/shared/js/shapes';
import themeStyles from '@client/shared/styles/theme/theme-styles.scss';
import styles from './collaboratePage.scss';

class CollaboratePage extends PureComponent {
  render() {
    return (
      <div className={styles.collaboratePage}>
        <HeroSection
          title={strings.collaborateHeroTitle}
          description={strings.collaborateHeroDescription}
          imageUrl={hero_collaborate}
          graphicsHeroMobile={shapes.graphic_header_mobile_2}
          graphicsHero={shapes.graphic_header_2}
        />
        <UspSection
          className={styles.uspSection}
          classNameDescriptionText={styles.uspDescription}
          title={strings.collaborateUspTitle}
          description={strings.collaborateUspDescription}
          imageUrl={collaborateUspImage}
        />
        <div
          className={styles.collaboratorsSection}
          style={{ backgroundImage: `url(${hero_collaborators})` }}
        >
          <div className={styles.collaboratorsContentContainer}>
            <div className={styles.collaboratePageSectionTitle}>
              {strings.collaboratorsTitle}
            </div>
            <div className={styles.collaboratorePageSectionLeadText}>
              {strings.collaboratorsLeadText}
            </div>
          </div>
          <picture>
            <source
              media="(max-width: 768px)"
              srcSet={shapes.graphic_about_mobile}
            />
            <img
              className={styles.shapeBottomRight}
              src={shapes.graphic_about}
              alt="Factuals graphic footer"
            />
          </picture>
        </div>
        <div className={styles.collaborateSection}>
          <div className={styles.topLeftContactUsBox}>
            <div className={styles.topLeftContactUsText}>
              {strings.collaborateFloatContact}
            </div>
            <div className={styles.topLeftContactUsText}>
              {strings.collaborateFloatUs}
            </div>
          </div>
          <div className={styles.collaborateContentContainer}>
            <div className={styles.collaboratePageSectionTitle}>
              {strings.collaborateSectionTitle}
            </div>
            <div className={styles.collaboratorePageSectionLeadText}>
              {strings.collaborateSectionLeadText}
            </div>
            <div className={`${themeStyles.subText} ${styles.subText}`}>
              <div className={styles.socialIconWrapper}>
                <i className={`icomoon icon-mail ${styles.socialIcon}`} />
              </div>
              <a href={`mailto:${strings.emailCollaborate}`}>
                <div className={styles.textWrapper}>
                  {strings.emailCollaborate}
                </div>
              </a>
            </div>
            <div className={`${themeStyles.subText} ${styles.subText}`}>
              <div className={styles.socialIconWrapper}>
                <i className={`icomoon icon-phone ${styles.socialIcon}`} />
              </div>
              <a href={`tel:${strings.phoneNumberCollaborateSection}`}>
                <div className={styles.textWrapper}>
                  {strings.phoneNumberCollaborateSection}
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

CollaboratePage.propTypes = {
  history: PropTypes.object,
  className: PropTypes.string,
  title: PropTypes.string,
  phonetics: PropTypes.string,
};

export default CollaboratePage;
